// extracted by mini-css-extract-plugin
export default {"leyenda":"CategoriaLeyendaIpsos_leyenda__ZM0r6"};